import React from 'react';
import { useOnboarding } from '../OnboardingProvider';
import { classNames } from '../../../Services/helpers';

const Progress = () => {
    const {steps, stepIndex, goTo, draft} = useOnboarding();

    return <div className="mb-6" aria-label={`Step ${stepIndex + 1} of ${steps.length}`}>
        <div className="flex gap-x-1.5">
            {steps.map((step, index) => {
                const isCompleted = draft.completedSteps.includes(step);
                const canJump = isCompleted && index < stepIndex;

                return <button
                    key={step}
                    type="button"
                    onClick={canJump ? () => goTo(step) : undefined}
                    disabled={!canJump}
                    aria-label={`Step ${index + 1}`}
                    className={classNames(
                        'h-1.5 flex-1 rounded-full transition-colors',
                        index <= stepIndex ? 'bg-brand' : 'surface-2',
                        canJump ? 'cursor-pointer' : 'cursor-default',
                    )}
                />;
            })}
        </div>
        {/* <p className="mt-2 text-xs text-muted">Step {stepIndex + 1} of {steps.length}</p> */}
    </div>;
};

export default Progress;
